import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';
import messageTemplatesApi from '@/features/dashboard/messageTemplates/api/messageTemplatesApi.ts';
import { messageTemplatesApiQueryKeys } from '@/features/dashboard/messageTemplates/api/messageTemplatesApi.queryKeys.ts';
import { MessageTemplateDto } from '@/features/dashboard/messageTemplates/types/MessageTemplateDto.ts';

const useUpdateMessageTemplate = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (dto: MessageTemplateDto) =>
      messageTemplatesApi.updateTemplate(
        dto.channel,
        dto.messageTemplateType,
        dto,
      ),
    onSuccess: (_data, dto) => {
      queryClient.invalidateQueries({
        queryKey: messageTemplatesApiQueryKeys.all(dto.channel),
      });
      toast.success('Szablon został zaktualizowany');
    },
    onError: (error: Error) => {
      toast.error('Nie udało się zaktualizować szablonu', {
        description: error.message,
      });
    },
  });
};

export default useUpdateMessageTemplate;
